import React from "react";
import { Card } from "antd";
import { useTranslation } from "react-i18next";

export default function GenderCard() {
    const { t } = useTranslation();
    const gender = [
        { name: t('customer_report.male'), value: 2, color: "#3b82f6" },
        { name: t('customer_report.female'), value: 3, color: "#22c55e" },
        { name: t('customer_report.unknown_gender'), value: 5, color: "#f59e0b" },
    ];

    const total = gender.reduce((sum, i) => sum + i.value, 0);

    return (
        <Card
            title={t('customer_report.gender')}
        >
            {/* Tổng */}
            <div>
                <div className="text-gray-500 dark:text-gray-400 text-sm">
                    {t('customer_report.customer')}
                </div>
                <div className="text-xl font-bold text-black dark:text-white">
                    {total}
                </div>
            </div>

            {/* Progress */}
            <div className="h-2 bg-gray-200 dark:bg-gray-700 mt-3 rounded overflow-hidden flex">
                {gender.map((g) => {
                    const percent = total ? (g.value / total) * 100 : 0;

                    return (
                        <div
                            key={g.name}
                            style={{
                                width: `${percent}%`,
                                background: g.color,
                            }}
                        />
                    );
                })}
            </div>

            {/* Header */}
            <div className="grid grid-cols-3 text-sm mt-4 font-medium text-gray-500 dark:text-gray-400">
                <div>{t('customer_report.gender')}</div>
                <div className="text-center">{t('customer_report.ratio')}</div>
                <div className="text-right">{t('customer_report.quantity')}</div>
            </div>

            {/* List */}
            {gender.map((g) => {
                const percent = total
                    ? ((g.value / total) * 100).toFixed(0)
                    : 0;

                return (
                    <div
                        key={g.name}
                        className="grid grid-cols-3 text-sm mt-2 items-center text-gray-800 dark:text-gray-200"
                    >
                        <div className="flex items-center gap-2">
                            <span
                                className="w-3 h-3 rounded-full"
                                style={{ background: g.color }}
                            />
                            {g.name}
                        </div>

                        <div className="text-center">{percent}%</div>
                        <div className="text-right">{g.value}</div>
                    </div>
                );
            })}
        </Card>
    );
}